module.exports = __webpack_public_path__ + "static/media/windows.ec38cff9.jpg";